import { render, staticRenderFns } from "./SelectedUserButton.vue?vue&type=template&id=0b9412cc&scoped=true&"
import script from "./SelectedUserButton.vue?vue&type=script&lang=ts&"
export * from "./SelectedUserButton.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedUserButton.vue?vue&type=style&index=0&id=0b9412cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9412cc",
  null
  
)

export default component.exports